export { default } from "./RangeHero";
